<template>
  <div>
    <Sidebar />
    <Header />
    <div class="container body-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import Header from './Header.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Header
  }
}
</script>

<style scoped>
/* 布局样式已在common.css中定义 */
</style> 